import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IEncodedTrackFormMeta {
    
    // Encoded Track
    track1: FormInputMeta;
    track1Format: FormInputMeta;
    track2: FormInputMeta;
    track2Format: FormInputMeta;
    track3: FormInputMeta;
    track3Format: FormInputMeta;
    
    [x: string]: FormInputMeta;
}
const encodedTrackFormMeta = {} as IEncodedTrackFormMeta;

// Encoded Track Form Fields
encodedTrackFormMeta.track1 = {
    name: "track1",
    type: "checkbox",
    label: "Piste 1",
    placeholder: "",
    validation: yup.boolean()
};

encodedTrackFormMeta.track1Format = {
    name: "track1Format",
    type: "select",
    label: "Format",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

encodedTrackFormMeta.track2 = {
    name: "track2",
    type: "checkbox",
    label: "Piste 2",
    placeholder: "",
    validation: yup.boolean()
};

encodedTrackFormMeta.track2Format = {
    name: "track2Format",
    type: "select",
    label: "Format",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

encodedTrackFormMeta.track3 = {
    name: "track3",
    type: "checkbox",
    label: "Piste 3",
    placeholder: "",
    validation: yup.boolean()
};

encodedTrackFormMeta.track3Format = {
    name: "track3Format",
    type: "select",
    label: "Format",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

export default encodedTrackFormMeta;